var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.dataReady)?_c('div',[_c('page-base',{attrs:{"disableNext":_vm.disableNext},on:{"onPrev":function($event){return _vm.onPrev()},"onNext":function($event){return _vm.onNext()}}},[_c('form-k',{on:{"enableNext":_vm.EnableNext}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }